import React from 'react';
import PropTypes from 'prop-types';

const ImageCaption = ({ caption }) => {
  if (!caption || !caption.trim()) {
    return null;
  }

  return <figcaption className="image-caption">{caption}</figcaption>;
};

ImageCaption.propTypes = {
  caption: PropTypes.string,
};

export default ImageCaption;
